export const SINGLE_WALL = {
    label: "Single Wall",
    value: 'SINGLE_WALL'
}

export const DOUBLE_WALL = {
    label: "Double Wall",
    value: "DOUBLE_WALL"
}